// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"163da725","239":"6cae256b","667":"b057950c"}[chunkId] + ".chunk.js";
};